import { ReolyzerFactory } from "../reolyzer/reolyzer-factory";

Office.onReady(() => {

    let map = null;

    if (!Office.context || !Office.context.ui) {
        console.warn("Not running inside Office dialog. Map will not be initialized.");
        return;
    }

    // Notify parent that the dialog is ready to receive data
    Office.context.ui.messageParent(JSON.stringify({ action: "readyForMapData" }));

    // Use window.external.dialogMessageReceived for cross-host compatibility
    Office.context.ui.addHandlerAsync(
        Office.EventType.DialogParentMessageReceived,
        (arg) => {
            const command = JSON.parse(arg.message);
            try {
                if (command.action === "updateMapData") {
                    if (Array.isArray(command.data) && command.data.length > 0) {
                        if (!map) {
                            map = ReolyzerFactory.createMap(command.data);
                        } else { 
                            map.updateMap(map.convertToMapPoints(command.data)); 
                        }
                    } else {
                        console.warn("Received empty or invalid data.");
                    }
                }
                // if (command.action === "updateMap") {
                //     if (!map) {
                //         console.log("Map object not initizialed.");
                //         return;
                //     } else {
                //         if (Array.isArray(command.data) && command.data.length > 0) {
                //             map.updateMap(command.data);
                //         } else {
                //             console.warn("Received empty or invalid data.");
                //         }
                //     }
                // }
            } catch (e) {
                console.error("Error parsing map data:", e);
            }
        });
});
